import React from 'react';
import {injectIntl} from "react-intl";

function TextArea({intl, settings, ...rest}) {
  const {label, placeholder, required = true, disabled = false, hidden = false, state, errors, divClasses = ''} = settings || {};
  let {name} = settings || {};
  if (rest.hasOwnProperty('name')) {
    name = rest.name;
  }

  const hasErrors = (errors && ((errors.hasOwnProperty(name) && errors[name].length) || errors.hasOwnProperty('generalError')));

  const id = `field--textarea--${name}`;

  const renderLabel = () => {
    if (!label) {
      return <label className="form-group__label" />;
    }
    else {
      return (
        <label className="form-group__label" htmlFor={id}>
          {intl.formatMessage({id: label})}
          {!required && <span className="form-group__optional"> {intl.formatMessage({id: 'FormElements.Label.Optional'})}</span>}
        </label>
      );
    }
  };

  const renderErrors = () => {
    const renderable = [];
    if (hasErrors && errors.hasOwnProperty(name) && errors[name].length) {
      renderable.push(
        <div key={`errorField-${name}`} className="form-group__feedback">{errors[name]}</div>
      );
    }
    return renderable;
  };

  if (hidden) {
    return '';
  }

  return (
    <div className={`form-group form-group--textarea ${hasErrors ? 'form-group--error' : ''} ${divClasses}`}>
      {renderLabel()}
      <div className="form-group__input">
        <textarea
          name={name}
          id={id}
          required={required}
          disabled={disabled}
          placeholder={placeholder && intl.formatMessage({id: placeholder}).toLowerCase()}
          value={(state && state.hasOwnProperty(name) ? state[name] : '')}
          {...rest}
        />
      </div>
      {renderErrors()}
    </div>
  );

}

export default injectIntl(TextArea);
